import { useCallback } from 'react';

import { useSendParticipantStateCallback } from '../../session/messages/useSendParticipantStateCallback';
import { UserType } from '../../types';
import { useVisitorId } from '../useVisitorId';

export function useSendVisitorParticipantStateCallback() {
  const visitorId = useVisitorId();

  const sendParticipantState = useSendParticipantStateCallback();

  return useCallback(() => {
    sendParticipantState({
      entityId: visitorId,
      entityType: UserType.CLIENT,
    });
  }, [sendParticipantState, visitorId]);
}
